export const environment = {
  production: true,
  mode: 'QA',
  authLoginUrl:
    'https://idm.dev.zsservices.com/Sanofi/IdentityManager/app/Web/login.aspx?ReturnUrl=',
  authLogoutUrl:
    'https://idm.dev.zsservices.com/Sanofi/IdentityManager/app/Web/logout.aspx',
  apiUrl: 'https://api.crt-sanofi.dev.zsservices.com/',
  errorHandling: {
    error_code_401: {
      Prod_url: 'https%3A%2F%2Fcrt-sanofi.zsservices.com',
      dev_url: 'https%3A%2F%2Fcrt-sanofi.dev.zsservices.com',
    },
    error_code_504: {
      Prod_url: 'https%3A%2F%2Fcrt-sanofi.zsservices.com',
      dev_url: 'https%3A%2F%2Fcrt-sanofi.dev.zsservices.com',
      message: 'Server is not responding. Please try again later.',
    },
    error_code_500: {
      message: 'Internal Server Error. Please try again later.',
    },
  },
};





